module.exports = __webpack_public_path__ + "static/SittingDoodle-b1c4fd431ae4f63f64ad1a12c155a4a2.png";